import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FFlowModule } from '@foblex/flow';
import { FlowNode } from '../../../models/flow-node.model';
import { FlowAbstractNodeComponent } from '../../flow-abstract-node.component';

@Component({
  selector: 'iot-platform-ui-flow-base-node',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FFlowModule],
  template: `
    <div class="node-wrapper min-h-38 min-w-82.5" data-test="node-wrapper">
      @if (label()) {
        <div class="node-pill-header {{ node()?.headerCssClassName }}" fDragHandle data-test="node-label">{{ label() }}</div>
      }
    </div>
  `
})
export class FlowBaseNodeComponent extends FlowAbstractNodeComponent<FlowNode, any> {}
